import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setIsDropdownOpen(false);
  };

  const getFlagSrc = () => {
    return currentLanguage === 'es'
      ? 'https://upload.wikimedia.org/wikipedia/commons/9/9a/Flag_of_Spain.svg'
      : 'https://upload.wikimedia.org/wikipedia/commons/6/64/Flag_of_Galicia.svg';
  };

  const getAltText = () => {
    return currentLanguage === 'es' ? 'ES' : 'GL';
  };

  const getTooltipText = (lang) => {
    return lang === 'es' ? 'Castellano' : 'Galego';
  };

  return (
    <div className="flex justify-end relative">
      <div className="flex items-center relative">
        <button
          className="flex items-center space-x-2 px-4 py-2 rounded-lg text-beast-brown-600 font-medium hover:bg-royal-gold-100 hover:text-royal-gold-800 active:scale-95 transition-all duration-300 shadow-sm hover:shadow-md"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <img
            src={getFlagSrc()}
            alt={getAltText()}
            className="w-6 h-4 object-cover rounded-sm"
          />
          <span>{getAltText()}</span>
          <svg
            className={`w-4 h-4 transition-transform duration-200 ${
              isDropdownOpen ? 'rotate-180' : ''
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>
        {isDropdownOpen && (
          <div className="absolute top-full right-0 mt-2 w-48 bg-castle-cream-100 rounded-lg shadow-lg overflow-hidden transform transition-all duration-200 ease-in-out">
            {currentLanguage !== 'es' && (
              <button
                className="w-full flex items-center space-x-3 px-4 py-3 text-beast-brown-600 font-medium hover:bg-royal-gold-100 hover:text-royal-gold-800 active:scale-95 transition-all duration-300"
                onClick={() => toggleLanguage('es')}
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/9/9a/Flag_of_Spain.svg"
                  alt="Español"
                  className="w-6 h-4 object-cover rounded-sm"
                />
                <span>{getTooltipText('es')}</span>
              </button>
            )}
            {currentLanguage !== 'gl' && (
              <button
                className="w-full flex items-center space-x-3 px-4 py-3 text-beast-brown-600 font-medium hover:bg-royal-gold-100 hover:text-royal-gold-800 active:scale-95 transition-all duration-300"
                onClick={() => toggleLanguage('gl')}
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/6/64/Flag_of_Galicia.svg"
                  alt="Galego"
                  className="w-6 h-4 object-cover rounded-sm"
                />
                <span>{getTooltipText('gl')}</span>
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
